import imageUrlBuilder from "@sanity/image-url";
import { envConfig } from "src/lib/client/envConfig";

const imgUrlBuilder = imageUrlBuilder({ projectId: envConfig.NEXT_PUBLIC_SANITY_PROJECTID, dataset: envConfig.NEXT_PUBLIC_KINOKLUBB_SANITY_DATASET });

export function urlForAsset(assetRef: string): ReturnType<typeof imageUrlBuilder> {
	return imgUrlBuilder.image(assetRef);
}